module.exports = __webpack_public_path__ + "static/media/use11_jpn.4d60c586.png";